import { motion } from 'framer-motion';

interface LanternProps {
  left?: string;
  delay?: number;
  size?: number;
}

export default function Lantern({ left = '50%', delay = 0, size = 1 }: LanternProps) {
  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{
        y: [-10, 15, -10],
        rotate: [-2, 2, -2],
        opacity: 1,
      }}
      transition={{
        duration: 8,
        delay,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
      style={{
        position: 'absolute',
        bottom: 0,
        left,
        transform: `scale(${size})`,
      }}
    >
      <div style={{ position: 'relative' }}>
        {/* Glow */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(255, 200, 80, 0.5)',
          filter: 'blur(20px)',
        }} />

        {/* Lantern body */}
        <div style={{
          position: 'relative',
          width: 56,
          height: 80,
          borderRadius: '0 0 16px 16px',
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          background: 'linear-gradient(to bottom, #FFF5E0, #FF9F1C, #D32F2F)',
          boxShadow: '0 0 40px rgba(255, 180, 80, 0.8)',
          border: '1px solid rgba(255, 215, 100, 0.3)',
        }} />

        {/* String */}
        <div style={{
          width: 2,
          height: 24,
          margin: '0 auto',
          background: 'rgba(255, 230, 150, 0.4)',
        }} />
      </div>
    </motion.div>
  );
}